
import { useNavigate } from 'react-router-dom';

export default function CategoryGrid() {
  const navigate = useNavigate();

  const categories = [
    {
      id: 'cars',
      name: 'السيارات',
      count: '24 مزاد',
      icon: 'https://www.soumqatar.com/static/media/cars.png',
      path: '/cars'
    },
    {
      id: 'real-estate',
      name: 'العقارات',
      count: '78 مزاد',
      icon: 'https://www.soumqatar.com/static/media/real-estate.png',
      path: '/real-estate'
    },
    {
      id: 'ships',
      name: 'السفن',
      count: '12 مزاد',
      icon: 'https://www.soumqatar.com/static/media/ships.png',
      path: '/ships'
    },
    {
      id: 'jewelry',
      name: 'المجوهرات',
      count: '8 مزاد',
      icon: 'https://www.soumqatar.com/static/media/jewelry.png',
      path: '/jewelry'
    },
    {
      id: 'arts',
      name: 'الفنون',
      count: '15 مزاد',
      icon: 'https://www.soumqatar.com/static/media/arts.png',
      path: '/arts'
    },
    {
      id: 'watches',
      name: 'الساعات',
      count: '6 مزاد',
      icon: 'https://www.soumqatar.com/static/media/watches.png',
      path: '/watches'
    },
    {
      id: 'antiques',
      name: 'التحف',
      count: '9 مزاد',
      icon: 'https://www.soumqatar.com/static/media/antiques.png',
      path: '/antiques'
    },
    {
      id: 'spare-parts',
      name: 'قطع الغيار',
      count: '22 مزاد',
      icon: 'https://www.soumqatar.com/static/media/spare-parts.png',
      path: '/spare-parts'
    },
    {
      id: 'electronics',
      name: 'الإلكترونيات',
      count: '16 مزاد',
      icon: 'https://www.soumqatar.com/static/media/electronics.png',
      path: '/electronics'
    },
    {
      id: 'jobs',
      name: 'الوظائف',
      count: '5 مزاد',
      icon: 'https://www.soumqatar.com/static/media/jobs.png',
      path: '/jobs'
    }
  ];

  return (
    <div className="px-4 mb-6">
      <h3 className="text-lg font-semibold mb-4">الفئات</h3>
      <div className="grid grid-cols-2 gap-4">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => navigate(category.path)}
            className="bg-gray-900 rounded-xl p-4 text-center hover:bg-gray-800 transition-colors"
          >
            <div className="w-16 h-16 mx-auto mb-3 rounded-lg overflow-hidden">
              <img
                src={category.icon}
                alt={category.name}
                className="w-full h-full object-cover"
                onError={(e) => {
                  // Fallback to generated images if original fails
                  const target = e.target as HTMLImageElement;
                  const fallbackImages: { [key: string]: string } = {
                    'cars': 'https://public.readdy.ai/ai/img_res/8a8b5fcb7b9f0ddc3974511098ec6f77.jpg',
                    'real-estate': 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20modern%20house%20building%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat2&orientation=squarish',
                    'ships': 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20luxury%20yacht%20and%20boat%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat14&orientation=squarish',
                    'jewelry': 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20diamond%20jewelry%20ring%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat3&orientation=squarish',
                    'arts': 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20art%20painting%20canvas%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat4&orientation=squarish',
                    'watches': 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20luxury%20watch%20timepiece%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat5&orientation=squarish',
                    'antiques': 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20antique%20vase%20artifact%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat6&orientation=squarish',
                    'spare-parts': 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20car%20engine%20parts%20and%20gears%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat10&orientation=squarish',
                    'electronics': 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20smartphone%20and%20laptop%20devices%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat11&orientation=squarish',
                    'jobs': 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20briefcase%20and%20office%20building%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat12&orientation=squarish'
                  };
                  target.src = fallbackImages[category.id] || fallbackImages['cars'];
                }}
              />
            </div>
            <h4 className="font-medium text-sm mb-1">{category.name}</h4>
            <p className="text-xs text-gray-400">{category.count}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
